module.exports = __webpack_public_path__ + "static/7-f4fcd4c557e675fb3a25cbaa4796f07e.png";